/* global fetchUrl budgets users types exportToFileUrl descriptions fromDate toDate */

import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import AuditLogsIndexTable from './AuditLogsIndexTable';

export default function AuditLogsIndex(props) {
    return (
        <AuditLogsIndexTable
            fetchUrl={props.fetchUrl}
            budgets={props.budgets}
            users={props.users}
            types={props.types}
            descriptions={props.descriptions}
            fromDate={props.fromDate}
            toDate={props.toDate}
            exportToFileUrl={exportToFileUrl}
        />
    );
}

if (document.getElementById('adminAuditLogs')) {
    var rootEl = document.getElementById('adminAuditLogs');
    ReactDOM.render(
        <App>
            <AuditLogsIndex
                fetchUrl={fetchUrl}
                budgets={JSON.parse(budgets)}
                users={JSON.parse(users)}
                types={JSON.parse(types)}
                descriptions={JSON.parse(descriptions)}
                fromDate={fromDate}
                toDate={toDate}
            />
        </App>,
        rootEl,
    );
}
